import React, { useEffect, useState } from "react"
import { IMessage } from "../../../types/messenger/IMessage"
import { download, getDateTime } from "../CommonHelper"
import { useStore } from "../../../stores/RootStoreContext"
import { IMG } from "../CONST"

export const Message: React.FC<{ message: IMessage }> = ({ message }) => {
  const { userStore } = useStore()
  const [chatUserName, setChatUserName] = useState<string[]>([])

  useEffect(() => {
    setChatUserName(getChatUserName)
  }, [message])

  const getChatUserName = () => {
    let resp: string[] = []
    if ((message.managerId && userStore.isManagement) || (!message.managerId && userStore.isClient)) {
      resp = ["you", "Вы"]
    }
    if (message.managerId && userStore.isClient) {
      resp = ["manager", "Менеджер"]
    }
    if (!message.managerId && userStore.isManagement) {
      resp = ["client", "Клиент"]
    }
    return resp
  }

  const getMsgClazzName = () => {
    if (message.metas && message.metas.length > 0) {
      return chatUserName[0] === "you" ? "file-my-chat" : "file-for-me-chat"
    } else {
      return chatUserName[0] === "you" ? "message-my-chat" : "message-for-me-chat"
    }
  }

  const downloadMsgFile = () => {
    if (!message.metas) return
    download(`${message.metas[0].id}`, "CHAT_FILE")
  }

  return (
    <li className={getMsgClazzName()}>
      <p className="username-message-chat">{chatUserName[1]}</p>
      {message.metas && message.metas.length > 0 ? (
        <>
          <img
            src={IMG.file_send}
            alt=""
            className="file-send-chat-message"
            style={{ cursor: "pointer" }}
            onClick={downloadMsgFile}
          />
          {message.metas[0].fileName}
        </>
      ) : (
        message.text
      )}
      <span className="message-date-time">{getDateTime(message.createdAt || "")}</span>
    </li>
  )
}
